import { AfterViewInit, ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { StudioMessageService } from '@studio/services/studio-message.service';
import { ThemeService } from '@web-desktop/controllers/theme.service';

@Component({
  selector: 'iu-studio',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './studio.component.html',
  styleUrl: './studio.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class StudioComponent implements AfterViewInit {
  private readonly studioMessageService = inject(StudioMessageService);
  private readonly themeService = inject(ThemeService);

  readonly message = this.studioMessageService.message;

  ngAfterViewInit(): void {
    this.themeService.setActiveTheme();
  }
}
